import CircularProgress from '@mui/material/CircularProgress'
import Box from '@mui/material/Box'
import type { SxProps } from '@mui/material/styles'

export default function Loader({ sx, wrapperSx }: { sx?: SxProps; wrapperSx?: SxProps }) {
    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh',
                backgroundColor: '#D2D9E1',
                svg: { circle: { stroke: '#ffffff' } },
                ...wrapperSx
            }}>
            <CircularProgress sx={{ ...sx }} />
        </Box>
    )
}
